// components/Footer/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTelegram, FaYoutube, FaArrowUp, FaTwitter } from 'react-icons/fa';
  import { FaTiktok } from 'react-icons/fa';
import './css/Footer.css';

const Footer = () => {
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer-wrapper" dir="rtl">
      
      {/* 1. Top Connect Bar */}
      <div className="connect-bar">
        <div className="container">
          <div className="connect-content">
            {/* Text Side (Right in RTL) */}
            <div className="connect-text">
              <h3 className="connect-heading">تواصلي معي عبر منصات التواصل</h3>
              {/* Decorative leaf SVG simulation */}
              <div className="leaf-decoration"></div>
            </div>

            {/* Icons Side (Left in RTL) */}
            <div className="social-icons">
              <a href="https://x.com/dr_nuhaalhazmi" target='_blank' className="social-link"><FaTwitter /></a>
              <a href="https://t.me/+966530494038" target='_blank' className="social-link"><FaTelegram /></a>
              <a href="https://www.youtube.com/@dr_nuhaalhazmi" target='_blank' className="social-link"><FaYoutube /></a>
              <a href="https://www.tiktok.com/@dr_nuhaalhazmi" target='_blank' className="social-link"><FaTiktok /></a>
            </div>
          </div>
        </div>
      </div>

      {/* 2. Main Footer Content */}
      <div className="main-footer">
        <div className="container">
          <div className="row">
            
            {/* Brand Column */}
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <div className="footer-brand">
                  <span className="brand-icon">د.</span>
                  <span className="brand-name">نهى الحازمي</span>
                </div>
                <p className="footer-bio">
                  لخدمات البحث العلمي والتوجيه الأكاديمي لطالبات الدراسات العليا.
                  رسالتي هي اختصار الطريق عليكِ، وحمايتك من الأخطاء المنهجية.
                </p>
                <div className="footer-copyright">
                  © 2026 جميع الحقوق محفوظة للدكتورة نهى الحازمي.
                </div>
              </motion.div>
            </div>

            {/* Links Column 1 */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-col-title">روابط هامة</h5>
              <ul className="footer-links">
                <li><Link to="/about">من أنا؟</Link></li>
                <li><Link to="/services">الخدمات والأسعار</Link></li>
                <li><Link to="/products">المنتجات الرقمية</Link></li>
                <li><Link to="/contact">اتصلي بي</Link></li>
              </ul>
            </div>

            {/* Links Column 2 */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-col-title">المساعدة</h5>
              <ul className="footer-links">
                <li><Link to="/faq">الأسئلة الشائعة</Link></li>
                <li><Link to="/products">المدونة</Link></li>
                <li><Link to="/services">ورش العمل</Link></li>
                <li><Link to="/">المجتمع</Link></li>
              </ul>
            </div>

            {/* Links Column 3 */}
            <div className="col-lg-4 col-md-12">
              <h5 className="footer-col-title">سياسات الموقع</h5>
              <ul className="footer-links">
                <li><Link to="/contact">الشروط والأحكام</Link></li>
                <li><Link to="/contact">سياسة الخصوصية</Link></li>
                <li><Link to="/contact">سياسة الاسترجاع</Link></li>
              </ul>
              
              {/* Optional: Newsletter Text */}
              <p className="newsletter-note mt-4">
                اشتركي في القائمة البريدية للحصول على آخر النصائح الأكاديمية.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button className="scroll-top-btn" onClick={scrollToTop} aria-label="Scroll to top">
        <FaArrowUp />
      </button>

    </footer>
  );
};

export default Footer;